__turbopack_context__.v({
  "avatarGroup": "index-module__TLnDna__avatarGroup",
  "expandable": "index-module__TLnDna__expandable",
  "medium": "index-module__TLnDna__medium",
  "small": "index-module__TLnDna__small",
});
